<app-header></app-header>


<div class="min-h-screen flex items-center short:items-start justify-center px-4 sm:px-6 md:px-8 short:pt-24 short:pb-8 bg-cover bg-center"
    [ngStyle]="{ 'background-image': 'url(assets/images/employee-login.png)' }">
    <div class="bg-white p-4 sm:p-6 md:p-8 short:py-3 rounded-lg w-full max-w-2xl mt-4 short:mt-0 card-shadow">
        <div class="flex justify-start mb-4 sm:mb-6 short:mb-2 pb-2 short:pb-1 border-b-[1px] ">
            <img src="assets/images/logo-red.png" class="h-10 sm:h-12 md:h-14 short:h-10" />
        </div>

        <h2 class="text-center text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mb-2">
            {{ 'EMPLOYEE.SIGNUP.TITLE' | translate }}
        </h2>
        <p class="text-center text-sm sm:text-base text-gray-500 mb-4 sm:mb-6 short:mb-2 font-light">
            {{ 'EMPLOYEE.SIGNUP.DESCRIPTION' | translate }}
        </p>

        <div class="flex justify-center">
            <div class="w-full max-w-md px-2 sm:px-0" (keydown.enter)="submitOnEnter()">
                <!-- API Error Message -->
                <div *ngIf="errorMessage" class="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 text-xs sm:text-sm rounded">
                    {{ errorMessage }}
                </div>
                <div class="mb-3 sm:mb-4 short:mb-2">
                    <label class="block text-xs sm:text-sm text-gray-400 mb-2 short:mb-1">{{ 'EMPLOYEE.SIGNUP.POLICY_NUMBER' | translate
                        }}</label>
                    <input class="w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-3xl focus:outline-none" [(ngModel)]="policyNumber"
                        placeholder="{{ 'EMPLOYEE.SIGNUP.POLICY_NUMBER' | translate }}" (input)="validatePolicyNumber()"
                        (blur)="policyNumberTouched = true" tabindex="1" [disabled]="isLoading" />
                    <div *ngIf="policyNumberTouched">
                        <div *ngFor="let error of policyNumberErrors" class="text-xs mt-1"
                            [ngClass]="{ 'text-yellow-500': error.includes('REQUIRED'), 'text-red-500': !error.includes('REQUIRED') }">
                            {{ error | translate }}
                        </div>
                    </div>
                </div>

                <div class="mb-3 sm:mb-4 short:mb-2">
                    <label class="block text-xs sm:text-sm text-gray-400 mb-2 short:mb-1">{{ 'EMPLOYEE.SIGNUP.MEMBER_NUMBER' | translate
                        }}</label>
                    <input class="w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-3xl focus:outline-none" [(ngModel)]="insuredNumber"
                        placeholder="{{ 'EMPLOYEE.SIGNUP.MEMBER_NUMBER_PLACEHOLDER' | translate }}"
                        (input)="validateInsuredNumber()" (blur)="insuredNumberTouched = true" tabindex="2"
                        [disabled]="isLoading" />
                    <div *ngIf="insuredNumberTouched">
                        <div *ngFor="let error of insuredNumberErrors" class="text-xs mt-1"
                            [ngClass]="{ 'text-yellow-500': error.includes('REQUIRED'), 'text-red-500': !error.includes('REQUIRED') }">
                            {{ error | translate }}
                        </div>
                    </div>
                </div>

                <div class="mb-3 sm:mb-4 short:mb-2">
                    <label class="block text-xs sm:text-sm text-gray-400 mb-2 short:mb-1">{{ 'EMPLOYEE.SIGNUP.EMAIL_ADDRESS' | translate
                        }}</label>
                    <input class="w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-3xl focus:outline-none" [(ngModel)]="email"
                        placeholder="{{ 'EMPLOYEE.SIGNUP.EMAIL_ADDRESS' | translate }}" (input)="validateEmail()"
                        (blur)="emailTouched = true" tabindex="3" [disabled]="isLoading" />
                    <div *ngIf="emailTouched">
                        <div *ngFor="let error of emailErrors" class="text-xs mt-1"
                            [ngClass]="{ 'text-yellow-500': error.includes('REQUIRED'), 'text-red-500': !error.includes('REQUIRED') }">
                            {{ error | translate }}
                        </div>
                    </div>
                </div>

                <div class="mb-3 sm:mb-4 short:mb-2">
                    <label class="block text-xs sm:text-sm text-gray-400 mb-2 short:mb-1">{{ 'EMPLOYEE.SIGNUP.CREATE_PASSWORD' | translate
                        }}</label>
                    <app-password-input
                        [(ngModel)]="password"
                        [placeholder]="'EMPLOYEE.SIGNUP.CREATE_PASSWORD' | translate"
                        [tabindex]="4"
                        [disabled]="isLoading"
                        (input)="validatePassword()"
                        (blur)="passwordTouched = true">
                    </app-password-input>
                    <div *ngIf="passwordTouched">
                        <div *ngFor="let error of passwordErrors" class="text-xs mt-1"
                            [ngClass]="{ 'text-yellow-500': error.includes('REQUIRED'), 'text-red-500': !error.includes('REQUIRED') }">
                            {{ error | translate }}
                        </div>
                    </div>
                    <div *ngIf="password" class="mt-1 sm:mt-2">
                        <div class="flex mt-1 h-1 sm:h-1.5 bg-gray-200 rounded overflow-hidden">
                            <div class="h-full" [ngStyle]="{
                                    'width': passwordStrength === 'weak' ? '33%' : passwordStrength === 'medium' ? '66%' : '100%',
                                    'background-color': passwordStrength === 'weak' ? '#EF4444' : passwordStrength === 'medium' ? '#F59E0B' : '#10B981'
                                }">
                            </div>
                        </div>
                        <p class="text-xs sm:text-sm mt-1" [ngClass]="{
                            'text-red-500': passwordStrength === 'weak',
                            'text-yellow-500': passwordStrength === 'medium',
                            'text-green-500': passwordStrength === 'strong'
                        }">
                            {{ passwordStrengthText }}
                        </p>
                    </div>
                </div>

                <div class="mb-4 sm:mb-6 short:mb-3">
                    <label class="block text-xs sm:text-sm text-gray-400 mb-2 short:mb-1">{{ 'EMPLOYEE.SIGNUP.CONFIRM_PASSWORD' | translate
                        }}</label>
                    <app-password-input
                        [(ngModel)]="confirmPassword"
                        [placeholder]="'EMPLOYEE.SIGNUP.CONFIRM_PASSWORD' | translate"
                        [tabindex]="5"
                        [disabled]="isLoading"
                        (input)="validateConfirmPassword()"
                        (blur)="confirmPasswordTouched = true">
                    </app-password-input>
                    <div *ngIf="confirmPasswordTouched">
                        <div *ngFor="let error of confirmPasswordErrors" class="text-xs mt-1"
                            [ngClass]="{ 'text-yellow-500': error.includes('REQUIRED'), 'text-red-500': !error.includes('REQUIRED') }">
                            {{ error | translate }}
                        </div>
                    </div>
                </div>

                <button (click)="register()" [disabled]="!isFormValid() || isLoading"
                    class="w-full rounded-3xl bg-white border-4 border-red-500 text-red-500 py-3 text-base sm:text-lg font-medium relative min-h-[48px]"
                    [ngClass]="{ 'opacity-50 cursor-default': !isFormValid() || isLoading, 'active:bg-red-500 active:text-white': isFormValid() && !isLoading }">
                    <span *ngIf="!isLoading">{{ 'EMPLOYEE.SIGNUP.SIGNUP_BUTTON' | translate | uppercase }}</span>
                    <span *ngIf="isLoading" class="flex items-center justify-center">
                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                        Processing...
                    </span>
                </button>

                <div class="text-center mt-4 sm:mt-6 short:mt-2">
                    <a routerLink="/employee/account/login" class="text-sm sm:text-base text-red-500 hover:underline min-h-[44px] inline-flex items-center">
                        {{ 'EMPLOYEE.SIGNUP.BACK_TO_LOGIN' | translate }}
                    </a>
                </div>

            </div>
        </div>

        <app-card-footer></app-card-footer>
    </div>
</div>